module.exports = __webpack_public_path__ + "img/monitor-01.4d6aa77c.svg";